__turbopack_context__.v({
  "accordionContainer": "ConnectionsBulkDeleteModal-module___k2qMW__accordionContainer",
  "connectionIcon": "ConnectionsBulkDeleteModal-module___k2qMW__connectionIcon",
  "connectionItem": "ConnectionsBulkDeleteModal-module___k2qMW__connectionItem",
  "connectionList": "ConnectionsBulkDeleteModal-module___k2qMW__connectionList",
});
